<template>
  <template v-if="getShow">
    <Form class="p-4 enter-x" :model="forgetFormData" :rules="getFormRules" ref="formRef">
      <FormItem name="email" class="enter-x">
        <Input
          size="large"
          v-model:value="forgetFormData.email"
          :placeholder="t('sys.login.emailPlaceholder')"
        >
          <template #prefix>
            <SvgIcon name="mail" size="18" />
          </template>
        </Input>
      </FormItem>

      <FormItem name="otp" class="enter-x">
        <Input
          size="large"
          v-model:value="forgetFormData.otp"
          :placeholder="t('sys.login.smsPlaceholder')"
          maxlength="6"
          oninput="value=value.replace(/[^\d]/g,'')"
        >
          <template #prefix>
            <SvgIcon name="lock-on" size="18" />
          </template>
          <template #suffix>
            <CountButton
              type="link"
              size="small"
              v-model:value="forgetFormData.otp"
              :placeholder="t('sys.login.smsCode')"
              :beforeStartFunc="handleSms"
            />
          </template>
        </Input>
      </FormItem>

      <FormItem class="enter-x">
        <Button type="primary" size="large" block @click="checkEmail" :loading="loading">
          {{ t('common.next') }}
        </Button>
        <section class="mt-6">
          <Alert
            v-show="sendSms"
            :message="t('sys.login.smsSended')"
            type="info"
            show-icon
            class="email-alert-info"
          >
            <template #icon>
              <SvgIcon name="success_transparent" size="13" />
            </template>
          </Alert>
        </section>
      </FormItem>
    </Form>
  </template>
</template>
<script lang="ts" setup>
  import { ref, computed, unref } from 'vue';
  import { Form, Input, Button, Alert } from 'ant-design-vue';
  import { CountButton } from '/@/components/CountDown';
  import { SvgIcon } from '/@/components/Icon';
  import { useI18n } from '@mcex/locale';
  import { useFormRules, useFormValid, useForgetPassState, ForgetPassStateEnum } from './useLogin';
  import { SendEmailCode, VerifyEmailCode } from '/@/api/sys/user';

  const FormItem = Form.Item;
  const { t } = useI18n();

  const formRef = ref();
  const loading = ref(false);
  const sendSms = ref(false);

  const { getFormRules } = useFormRules();
  const { validForm } = useFormValid(formRef);

  const { getForgetPassState, setForgetPassState, forgetFormData } = useForgetPassState();
  const getShow = computed(() => unref(getForgetPassState) === ForgetPassStateEnum.CHECK_EMAIL);

  const handleSms = async () => {
    // TODO: 发送验证码
    try {
      const queryParams = {
        email: forgetFormData.email,
      };
      await SendEmailCode(queryParams);

      sendSms.value = true;
      return true;
    } catch (error) {
      sendSms.value = false;
      return false;
    }
  };

  async function checkEmail() {
    const data = await validForm();
    if (!data) return;
    try {
      loading.value = true;
      // TODO: 验证
      const queryParams = {
        email: forgetFormData.email,
        otp: forgetFormData.otp,
      };
      await VerifyEmailCode(queryParams);
      setForgetPassState(ForgetPassStateEnum.RESET_PASSWORD);
    } catch (error) {
    } finally {
      loading.value = false;
    }
  }
</script>
<style lang="less">
  @link-cls: ~'@{namespace}-link';
  .@{link-cls} {
    color: @other-link-color;
  }

  .email-alert-info {
    background-color: rgba(69, 191, 176, 0.2);
    border-color: rgba(69, 191, 176, 1);

    .ant-alert-message {
      color: #fff;
    }
  }
</style>
